import { useEffect } from 'react';
import Button from '../inputs/Button';
import * as Sentry from '@sentry/react';

export default function BuilderErrorFallback({ error, resetErrorBoundary }) {
  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <div className="flex flex-col h-screen w-screen justify-center items-center">
      <div className="mb-6">
        Uh oh, something went wrong. Please reset the builder.
      </div>
      <Button type="text" onClick={resetErrorBoundary} primary>
        Reset
      </Button>
    </div>
  );
}
